/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-26 15:34:44
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-07-21 15:44:19
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/Import/index.tsx
 */
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import React from 'react';
import { ModalFooter } from 'src/components/Antd';
import { Upload } from 'src/components/Antd/Uploader/Uploader';
import { GreenHref } from 'src/components/Link/GreenLink';
import LoadLanding from 'src/components/LoadLanding';
import { useI18n } from 'src/hooks/useRouterChange';
import { msg } from 'src/tools/message';
import { getBaseUrl } from 'src/tools/server';
import { i18nGet } from 'src/tools/tools';
import reqwest from 'src/utils/reqest';
import css from './css.module.less';

const DEFAULTDOWNLOADURL =
  'https://www.stats.govt.nz/assets/Uploads/Business-operations-survey/Business-operations-survey-2020/Download-data/business-operations-survey-2020-covid-19-csv.csv';

const DEFAULTDOWNLOADTEXT = `sample CSV template`;

const Import = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    onCancel,
    onSuccess,
    downloadUrl,
    uploadUrl,
    downloadText,
    modalOkText,
    formDataKey,
    accept,
    hideSampleDownload,
  } = props;

  const [fileList, setFileList] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const handleUpload = () => {
    const formData = new FormData();
    fileList.forEach((file) => {
      formData.append(formDataKey || 'files[]', file);
    });
    setLoading(true);

    reqwest.on({
      url: `${getBaseUrl()}${
        uploadUrl ? uploadUrl : 'portal/productReview/import'
      }`,
      method: 'post',
      processData: false,
      data: formData,

      success: () => {
        setFileList([]);
        setLoading(false);
        msg.success(getI18n('general.done'));
        if (onSuccess) onSuccess();
        // this.setState({
        //   fileList: [],
        //   uploading: false,
        // });
        // message.success('upload successfully.');
      },
      error: () => {
        setLoading(false);
        msg.error('Internet Issue');
        // this.setState({
        //   uploading: false,
        // });
        // message.error('upload failed.');
      },
    });
  };
  const _props = {
    name: 'file',
    accept: accept || '.csv,.excel',
    onRemove: (file) => {
      setFileList([]);
    },
    beforeUpload: (file) => {
      setFileList([file]);
      return false;
    },
    fileList,
  };
  return (
    <React.Fragment>
      <div className={css.container}>
        <ItemWrapper
          title={
            <span style={{ fontWeight: 700 }}>
              {getI18n('general.antd.Uploader.upload_files')}
            </span>
          }
          {...(!hideSampleDownload && {
            rightPart: (
              <div>
                {getI18n('general.download')}
                <GreenHref
                  target='_blank'
                  href={`${downloadUrl || DEFAULTDOWNLOADURL}`}>
                  &nbsp; {downloadText || DEFAULTDOWNLOADTEXT}
                </GreenHref>
              </div>
            ),
          })}>
          <Upload {..._props} fileList={fileList}>
            {fileList.length > 0 ? null : <LoadLanding />}
          </Upload>
        </ItemWrapper>
      </div>
      <ModalFooter
        onCancel={onCancel}
        loading={loading}
        onOk={handleUpload}
        okText={modalOkText || getI18n('general.import')}
        cancelText={getI18n('general.cancel')}
        hideOkButton={fileList.length === 0}
      />
    </React.Fragment>
  );
};
export default Import;
